import { Stack } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import TextFieldController from '@/components/inputs/TextFieldController'
import { formatLimitValue } from '@/features/site/components/availability/utils'
import type { MarketProgram } from '@/features/site/types/marketProgram'
import type { ServiceRuleForm } from '@/features/site/types/serviceRuleForm'

export const ServiceRuleConditionSection = (props: { marketProgram: MarketProgram; contractPrice: number }) => {
  const { t } = useTranslation()

  const { formState } = useFormContext<ServiceRuleForm>()

  return (
    <>
      <Typography variant="h6">
        {t('customer_details.tabs.availability.availability_details.dialog.conditions_section.title')}
      </Typography>
      <Stack alignItems={'center'} direction={'row'} spacing={2}>
        <Typography variant="h4">
          {t('customer_details.tabs.availability.availability_details.dialog.conditions_section.info_message')}
        </Typography>
        <TextFieldController
          disabled
          error={formState.errors?.limitValue !== undefined}
          helperText={formState.errors?.limitValue?.message}
          label={t('customer_details.tabs.availability.availability_details.limit_value.price.label')}
          name={`limitValue`}
          sx={{ width: 200 }}
          value={formatLimitValue(t, props.marketProgram.type, props.contractPrice)}
        />
      </Stack>
    </>
  )
}
